export default __webpack_public_path__ + "static/media/library.5faf6834.svg";